/* eslint-disable prettier/prettier */
import axios from 'http.service';
import apiErrorMsg from 'Common/Utils/apiErrorMsg';

const baseUrl = '/api/v2/taskhistory/all';

export const getTaskHistory = async (errorCb) => {
    const {
		status,
		data: { data, errors }
    } = await axios.get(baseUrl);
    if (status === 200) {
		return data;
    }
	const errorMessage = apiErrorMsg(status, errors);
	return errorCb(errorMessage);
};
